// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TTInsights Dashboard Styles */

:root {
    --tt-primary: #0d6efd;
    --tt-success: #198754;
    --tt-danger: #dc3545;
    --tt-warning: #ffc107;
    --tt-info: #0dcaf0;
    --tt-light: #f8f9fa;
    --tt-dark: #212529;
    --tt-muted: #6c757d;
    --tt-border: #e9ecef;
    --tt-border-dark: #dee2e6;
  
    --tt-spacing-xs: 0.5rem;
    --tt-spacing-sm: 0.75rem;
    --tt-spacing-md: 1rem;
    --tt-spacing-lg: 1.5rem;
    --tt-spacing-xl: 2rem;
  
    --tt-radius: 6px;
    --tt-radius-lg: 8px;
  
    --tt-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
    --tt-shadow-md: 0 1px 3px rgba(0, 0, 0, 0.08);
    --tt-shadow-lg: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  /* ==================== GENERAL ====================  */
  
  .tt-container {
    font-size: 14px;
    background-color: var(--tt-light);
    min-height: 100vh;
  }
  
  .tt-page-header {
    padding-bottom: var(--tt-spacing-lg);
    border-bottom: 2px solid var(--tt-border);
    margin-bottom: var(--tt-spacing-lg);
  }
  
  .tt-page-title {
    font-size: 24px;
    font-weight: 600;
    color: var(--tt-dark);
    margin: 0;
    display: flex;
    align-items: center;
    gap: var(--tt-spacing-sm);
  }
  
  .tt-page-subtitle {
    font-size: 13px;
    color: var(--tt-muted);
    margin: var(--tt-spacing-xs) 0 0 0;
  }
  
  /* ==================== ALERTS ====================  */
  
  .tt-alert {
    border-radius: var(--tt-radius);
    border-left: 4px solid;
    padding: var(--tt-spacing-md);
    margin-bottom: var(--tt-spacing-lg);
    display: flex;
    align-items: flex-start;
    gap: var(--tt-spacing-sm);
  }
  
  .tt-alert-danger {
    border-left-color: var(--tt-danger);
    background-color: #fff5f5;
    color: var(--tt-danger);
  }
  
  .tt-alert-success {
    border-left-color: var(--tt-success);
    background-color: #f1fdf4;
    color: var(--tt-success);
  }
  
  .tt-alert-warning {
    border-left-color: var(--tt-warning);
    background-color: #fffbea;
    color: #856404;
  }
  
  .tt-alert-info {
    border-left-color: var(--tt-info);
    background-color: #f0f8ff;
    color: var(--tt-info);
  }
  
  .tt-alert-icon {
    font-weight: bold;
    margin-top: 2px;
    flex-shrink: 0;
  }
  
  /* ==================== CONTROLS SECTION ====================  */
  
  .tt-controls {
    background-color: #ffffff;
    border-radius: var(--tt-radius-lg);
    padding: var(--tt-spacing-lg);
    margin-bottom: var(--tt-spacing-lg);
    box-shadow: var(--tt-shadow-sm);
    border: 1px solid var(--tt-border);
  }
  
  .tt-control-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--tt-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: var(--tt-spacing-sm);
    display: block;
  }
  
  .tt-button {
    display: inline-flex;
    align-items: center;
    gap: var(--tt-spacing-sm);
    padding: 0.5rem 1rem;
    border-radius: var(--tt-radius);
    border: 1px solid transparent;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    white-space: nowrap;
  }
  
  .tt-button:hover {
    transform: translateY(-1px);
    box-shadow: var(--tt-shadow-md);
  }
  
  .tt-button:active {
    transform: translateY(0);
  }
  
  .tt-button-primary {
    background-color: var(--tt-primary);
    color: #ffffff;
    border-color: var(--tt-primary);
  }
  
  .tt-button-primary:hover {
    background-color: #0b5ed7;
  }
  
  .tt-button-success {
    background-color: var(--tt-success);
    color: #ffffff;
    border-color: var(--tt-success);
  }
  
  .tt-button-success:hover {
    background-color: #157347;
  }
  
  .tt-button-warning {
    background-color: var(--tt-warning);
    color: #000000;
    border-color: var(--tt-warning);
  }
  
  .tt-button-warning:hover {
    background-color: #ffca2c;
  }
  
  .tt-button-outline {
    background-color: transparent;
    border-color: var(--tt-border);
    color: var(--tt-muted);
  }
  
  .tt-button-outline:hover {
    background-color: var(--tt-light);
    color: var(--tt-dark);
  }
  
  .tt-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
  
  /* ==================== CARDS ====================  */
  
  .tt-card {
    background-color: #ffffff;
    border: 1px solid var(--tt-border);
    border-radius: var(--tt-radius);
    padding: var(--tt-spacing-md);
    margin-bottom: var(--tt-spacing-md);
    box-shadow: var(--tt-shadow-sm);
    transition: box-shadow 0.2s ease;
  }
  
  .tt-card:hover {
    box-shadow: var(--tt-shadow-md);
  }
  
  .tt-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: var(--tt-spacing-md);
    padding-bottom: var(--tt-spacing-sm);
    border-bottom: 1px solid var(--tt-border);
  }
  
  .tt-card-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--tt-dark);
    margin: 0;
    display: flex;
    align-items: center;
    gap: var(--tt-spacing-xs);
  }
  
  .tt-card-subtitle {
    font-size: 12px;
    color: var(--tt-muted);
    margin: var(--tt-spacing-xs) 0 0 0;
  }
  
  /* ==================== TABLES ====================  */
  
  .tt-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0;
    font-size: 13px;
  }
  
  .tt-table thead {
    background-color: var(--tt-light);
    border-bottom: 2px solid var(--tt-border-dark);
  }
  
  .tt-table th {
    font-size: 12px;
    font-weight: 600;
    color: var(--tt-dark);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: var(--tt-spacing-sm);
    text-align: left;
    border-color: var(--tt-border-dark);
  }
  
  .tt-table td {
    padding: var(--tt-spacing-sm);
    border-bottom: 1px solid var(--tt-border);
    vertical-align: middle;
    color: var(--tt-dark);
  }
  
  .tt-table tbody tr:hover {
    background-color: var(--tt-light);
  }
  
  .tt-table tbody tr:nth-child(even) {
    background-color: #fafbfc;
  }
  
  .tt-table-align-right {
    text-align: right;
  }
  
  .tt-table-align-center {
    text-align: center;
  }
  
  /* ==================== BADGES ====================  */
  
  .tt-badge {
    display: inline-block;
    padding: var(--tt-spacing-xs) var(--tt-spacing-sm);
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
  }
  
  .tt-badge-primary {
    background-color: var(--tt-primary);
    color: #ffffff;
  }
  
  .tt-badge-success {
    background-color: var(--tt-success);
    color: #ffffff;
  }
  
  .tt-badge-danger {
    background-color: var(--tt-danger);
    color: #ffffff;
  }
  
  .tt-badge-warning {
    background-color: var(--tt-warning);
    color: #000000;
  }
  
  .tt-badge-info {
    background-color: var(--tt-info);
    color: #ffffff;
  }
  
  .tt-badge-light {
    background-color: var(--tt-light);
    color: var(--tt-dark);
    border: 1px solid var(--tt-border);
  }
  
  /* ==================== STAT CARDS ====================  */
  
  .tt-stat-card {
    text-align: center;
    padding-bottom: var(--tt-spacing-lg);
  }
  
  .tt-stat-icon {
    font-size: 28px;
    margin-bottom: var(--tt-spacing-sm);
  }
  
  .tt-stat-label {
    font-size: 12px;
    color: var(--tt-muted);
    margin-bottom: var(--tt-spacing-xs);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .tt-stat-value {
    font-size: 24px;
    font-weight: 600;
    color: var(--tt-primary);
    margin-bottom: var(--tt-spacing-sm);
  }
  
  .tt-stat-subtext {
    font-size: 12px;
    color: var(--tt-muted);
    margin: 0;
  }
  
  .tt-stat-trend {
    display: inline-block;
    margin-left: var(--tt-spacing-xs);
    font-weight: 500;
  }
  
  .tt-stat-trend-up {
    color: var(--tt-success);
  }
  
  .tt-stat-trend-down {
    color: var(--tt-danger);
  }
  
  /* ==================== EMPTY STATES ====================  */
  
  .tt-empty-state {
    text-align: center;
    padding: var(--tt-spacing-xl);
    color: var(--tt-muted);
  }
  
  .tt-empty-icon {
    font-size: 48px;
    margin-bottom: var(--tt-spacing-md);
  }
  
  .tt-empty-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--tt-dark);
    margin-bottom: var(--tt-spacing-sm);
  }
  
  .tt-empty-description {
    font-size: 13px;
    margin-bottom: var(--tt-spacing-md);
    line-height: 1.5;
  }
  
  /* ==================== LOADING STATES ====================  */
  
  .tt-loading {
    text-align: center;
    padding: var(--tt-spacing-xl);
  }
  
  .tt-loading-spinner {
    margin-bottom: var(--tt-spacing-md);
  }
  
  .tt-loading-text {
    color: var(--tt-muted);
    font-size: 13px;
  }
  
  /* ==================== TABS ====================  */
  
  .tt-tabs {
    background-color: #ffffff;
    border-radius: var(--tt-radius-lg);
    box-shadow: var(--tt-shadow-sm);
    overflow: hidden;
  }
  
  .tt-tabs-nav {
    display: flex;
    border-bottom: 2px solid var(--tt-border);
    background-color: var(--tt-light);
    overflow-x: auto;
  }
  
  .tt-tab-button {
    padding: var(--tt-spacing-md) var(--tt-spacing-lg);
    border: none;
    background-color: transparent;
    color: var(--tt-muted);
    cursor: pointer;
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    transition: all 0.2s ease;
    border-bottom: 3px solid transparent;
    margin-bottom: -2px;
  }
  
  .tt-tab-button:hover {
    color: var(--tt-dark);
    background-color: rgba(13, 110, 253, 0.05);
  }
  
  .tt-tab-button.active {
    color: var(--tt-primary);
    border-bottom-color: var(--tt-primary);
  }
  
  .tt-tab-badge {
    display: inline-block;
    background-color: var(--tt-danger);
    color: #ffffff;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 10px;
    font-weight: 600;
    margin-left: var(--tt-spacing-xs);
    vertical-align: middle;
  }
  
  .tt-tab-content {
    padding: var(--tt-spacing-lg);
  }
  
  /* ==================== FORMS ====================  */
  
  .tt-form-group {
    margin-bottom: var(--tt-spacing-md);
  }
  
  .tt-form-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: var(--tt-dark);
    margin-bottom: var(--tt-spacing-xs);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .tt-form-input,
  .tt-form-select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 13px;
    border: 1px solid var(--tt-border);
    border-radius: var(--tt-radius);
    background-color: #ffffff;
    color: var(--tt-dark);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  
  .tt-form-input:focus,
  .tt-form-select:focus {
    outline: none;
    border-color: var(--tt-primary);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  }
  
  .tt-form-input:disabled,
  .tt-form-select:disabled {
    background-color: var(--tt-light);
    color: var(--tt-muted);
    cursor: not-allowed;
  }
  
  /* ==================== RESPONSIVE ====================  */
  
  @media (max-width: 768px) {
    .tt-page-title {
      font-size: 20px;
    }
  
    .tt-controls {
      padding: var(--tt-spacing-md);
    }
  
    .tt-card {
      padding: var(--tt-spacing-sm);
    }
  
    .tt-table {
      font-size: 12px;
    }
  
    .tt-table th,
    .tt-table td {
      padding: var(--tt-spacing-xs);
    }
  
    .tt-tab-button {
      padding: var(--tt-spacing-sm) var(--tt-spacing-md);
      font-size: 12px;
    }
  
    .tt-stat-value {
      font-size: 20px;
    }
  }
  
  @media (max-width: 576px) {
    .tt-page-title {
      font-size: 18px;
    }
  
    .tt-tabs-nav {
      flex-wrap: wrap;
    }
  
    .tt-tab-button {
      padding: var(--tt-spacing-xs) var(--tt-spacing-sm);
      font-size: 11px;
    }
  
    .tt-stat-icon {
      font-size: 24px;
    }
  
    .tt-stat-value {
      font-size: 18px;
    }
  }
  
  /* ==================== UTILITIES ====================  */
  
  .tt-text-center {
    text-align: center;
  }
  
  .tt-text-right {
    text-align: right;
  }
  
  .tt-text-muted {
    color: var(--tt-muted);
  }
  
  .tt-text-success {
    color: var(--tt-success);
  }
  
  .tt-text-danger {
    color: var(--tt-danger);
  }
  
  .tt-text-warning {
    color: var(--tt-warning);
  }
  
  .tt-text-primary {
    color: var(--tt-primary);
  }
  
  .tt-mb-0 {
    margin-bottom: 0;
  }
  
  .tt-mb-1 {
    margin-bottom: var(--tt-spacing-xs);
  }
  
  .tt-mb-2 {
    margin-bottom: var(--tt-spacing-sm);
  }
  
  .tt-mb-3 {
    margin-bottom: var(--tt-spacing-md);
  }
  
  .tt-mb-4 {
    margin-bottom: var(--tt-spacing-lg);
  }
  
  .tt-mb-5 {
    margin-bottom: var(--tt-spacing-xl);
  }
  
  .tt-mt-0 {
    margin-top: 0;
  }
  
  .tt-mt-1 {
    margin-top: var(--tt-spacing-xs);
  }
  
  .tt-mt-2 {
    margin-top: var(--tt-spacing-sm);
  }
  
  .tt-mt-3 {
    margin-top: var(--tt-spacing-md);
  }
  
  .tt-mt-4 {
    margin-top: var(--tt-spacing-lg);
  }
  
  .tt-mt-5 {
    margin-top: var(--tt-spacing-xl);
  }
  
  .tt-p-0 {
    padding: 0;
  }
  
  .tt-p-1 {
    padding: var(--tt-spacing-xs);
  }
  
  .tt-p-2 {
    padding: var(--tt-spacing-sm);
  }
  
  .tt-p-3 {
    padding: var(--tt-spacing-md);
  }
  
  .tt-p-4 {
    padding: var(--tt-spacing-lg);
  }
  
  .tt-p-5 {
    padding: var(--tt-spacing-xl);
  }
  
  .tt-gap-1 {
    gap: var(--tt-spacing-xs);
  }
  
  .tt-gap-2 {
    gap: var(--tt-spacing-sm);
  }
  
  .tt-gap-3 {
    gap: var(--tt-spacing-md);
  }
  
  .tt-gap-4 {
    gap: var(--tt-spacing-lg);
  }
  
  .tt-gap-5 {
    gap: var(--tt-spacing-xl);
  }
  
  .tt-d-flex {
    display: flex;
  }
  
  .tt-d-grid {
    display: grid;
  }
  
  .tt-align-items-center {
    align-items: center;
  }
  
  .tt-justify-content-between {
    justify-content: space-between;
  }
  
  .tt-justify-content-center {
    justify-content: center;
  }
  
  .tt-flex-wrap {
    flex-wrap: wrap;
  }
  
  .tt-w-100 {
    width: 100%;
  }
  
  .tt-h-100 {
    height: 100%;
  }
  
  .tt-overflow-hidden {
    overflow: hidden;
  }
  
  .tt-overflow-auto {
    overflow: auto;
  }
  
  .tt-cursor-pointer {
    cursor: pointer;
  }
  
  .tt-cursor-default {
    cursor: default;
  }
  
  .tt-opacity-50 {
    opacity: 0.5;
  }
  
  .tt-opacity-75 {
    opacity: 0.75;
  }
  
  .tt-rounded {
    border-radius: var(--tt-radius);
  }
  
  .tt-rounded-lg {
    border-radius: var(--tt-radius-lg);
  }
  
  .tt-shadow-sm {
    box-shadow: var(--tt-shadow-sm);
  }
  
  .tt-shadow-md {
    box-shadow: var(--tt-shadow-md);
  }
  
  .tt-shadow-lg {
    box-shadow: var(--tt-shadow-lg);
  }
  
  .tt-border {
    border: 1px solid var(--tt-border);
  }
  
  .tt-border-bottom {
    border-bottom: 1px solid var(--tt-border);
  }
  
  .tt-border-top {
    border-top: 1px solid var(--tt-border);
  }
  
  .tt-nowrap {
    white-space: nowrap;
  }
  
  .tt-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }`, "",{"version":3,"sources":["webpack://./src/features/tt-insights/styles/tt-insights.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;IACI,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;;IAEzB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;;IAErB,gBAAgB;IAChB,mBAAmB;;IAEnB,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA,uDAAuD;;EAEvD;IACE,eAAe;IACf,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA,sDAAsD;;EAEtD;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,6BAA6B;IAC7B,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA,gEAAgE;;EAEhE;IACE,yBAAyB;IACzB,kCAAkC;IAClC,6BAA6B;IAC7B,mCAAmC;IACnC,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,+BAA+B;IAC/B,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA,qDAAqD;;EAErD;IACE,yBAAyB;IACzB,kCAAkC;IAClC,+BAA+B;IAC/B,6BAA6B;IAC7B,mCAAmC;IACnC,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA,sDAAsD;;EAEtD;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iCAAiC;IACjC,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mCAAmC;EACrC;;EAEA;IACE,6BAA6B;IAC7B,yCAAyC;IACzC,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sDAAsD;;EAEtD;IACE,qBAAqB;IACrB,kDAAkD;IAClD,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA,0DAA0D;;EAE1D;IACE,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,mCAAmC;IACnC,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,4DAA4D;;EAE5D;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,mCAAmC;IACnC,gBAAgB;EAClB;;EAEA,8DAA8D;;EAE9D;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,oDAAoD;;EAEpD;IACE,yBAAyB;IACzB,kCAAkC;IAClC,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,yCAAyC;IACzC,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,kDAAkD;IAClD,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;IACrB,kCAAkC;IAClC,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,qDAAqD;;EAErD;IACE,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mCAAmC;IACnC,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kCAAkC;IAClC,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD;EAC1D;;EAEA;;IAEE,aAAa;IACb,+BAA+B;IAC/B,6CAA6C;EAC/C;;EAEA;;IAEE,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,0DAA0D;;EAE1D;IACE;MACE,eAAe;IACjB;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,eAAe;IACjB;;IAEA;;MAEE,6BAA6B;IAC/B;;IAEA;MACE,kDAAkD;MAClD,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kDAAkD;MAClD,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,yDAAyD;;EAEzD;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB","sourcesContent":["/* TTInsights Dashboard Styles */\n\n:root {\n    --tt-primary: #0d6efd;\n    --tt-success: #198754;\n    --tt-danger: #dc3545;\n    --tt-warning: #ffc107;\n    --tt-info: #0dcaf0;\n    --tt-light: #f8f9fa;\n    --tt-dark: #212529;\n    --tt-muted: #6c757d;\n    --tt-border: #e9ecef;\n    --tt-border-dark: #dee2e6;\n  \n    --tt-spacing-xs: 0.5rem;\n    --tt-spacing-sm: 0.75rem;\n    --tt-spacing-md: 1rem;\n    --tt-spacing-lg: 1.5rem;\n    --tt-spacing-xl: 2rem;\n  \n    --tt-radius: 6px;\n    --tt-radius-lg: 8px;\n  \n    --tt-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);\n    --tt-shadow-md: 0 1px 3px rgba(0, 0, 0, 0.08);\n    --tt-shadow-lg: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* ==================== GENERAL ====================  */\n  \n  .tt-container {\n    font-size: 14px;\n    background-color: var(--tt-light);\n    min-height: 100vh;\n  }\n  \n  .tt-page-header {\n    padding-bottom: var(--tt-spacing-lg);\n    border-bottom: 2px solid var(--tt-border);\n    margin-bottom: var(--tt-spacing-lg);\n  }\n  \n  .tt-page-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--tt-dark);\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: var(--tt-spacing-sm);\n  }\n  \n  .tt-page-subtitle {\n    font-size: 13px;\n    color: var(--tt-muted);\n    margin: var(--tt-spacing-xs) 0 0 0;\n  }\n  \n  /* ==================== ALERTS ====================  */\n  \n  .tt-alert {\n    border-radius: var(--tt-radius);\n    border-left: 4px solid;\n    padding: var(--tt-spacing-md);\n    margin-bottom: var(--tt-spacing-lg);\n    display: flex;\n    align-items: flex-start;\n    gap: var(--tt-spacing-sm);\n  }\n  \n  .tt-alert-danger {\n    border-left-color: var(--tt-danger);\n    background-color: #fff5f5;\n    color: var(--tt-danger);\n  }\n  \n  .tt-alert-success {\n    border-left-color: var(--tt-success);\n    background-color: #f1fdf4;\n    color: var(--tt-success);\n  }\n  \n  .tt-alert-warning {\n    border-left-color: var(--tt-warning);\n    background-color: #fffbea;\n    color: #856404;\n  }\n  \n  .tt-alert-info {\n    border-left-color: var(--tt-info);\n    background-color: #f0f8ff;\n    color: var(--tt-info);\n  }\n  \n  .tt-alert-icon {\n    font-weight: bold;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n  \n  /* ==================== CONTROLS SECTION ====================  */\n  \n  .tt-controls {\n    background-color: #ffffff;\n    border-radius: var(--tt-radius-lg);\n    padding: var(--tt-spacing-lg);\n    margin-bottom: var(--tt-spacing-lg);\n    box-shadow: var(--tt-shadow-sm);\n    border: 1px solid var(--tt-border);\n  }\n  \n  .tt-control-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--tt-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: var(--tt-spacing-sm);\n    display: block;\n  }\n  \n  .tt-button {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--tt-spacing-sm);\n    padding: 0.5rem 1rem;\n    border-radius: var(--tt-radius);\n    border: 1px solid transparent;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n  \n  .tt-button:hover {\n    transform: translateY(-1px);\n    box-shadow: var(--tt-shadow-md);\n  }\n  \n  .tt-button:active {\n    transform: translateY(0);\n  }\n  \n  .tt-button-primary {\n    background-color: var(--tt-primary);\n    color: #ffffff;\n    border-color: var(--tt-primary);\n  }\n  \n  .tt-button-primary:hover {\n    background-color: #0b5ed7;\n  }\n  \n  .tt-button-success {\n    background-color: var(--tt-success);\n    color: #ffffff;\n    border-color: var(--tt-success);\n  }\n  \n  .tt-button-success:hover {\n    background-color: #157347;\n  }\n  \n  .tt-button-warning {\n    background-color: var(--tt-warning);\n    color: #000000;\n    border-color: var(--tt-warning);\n  }\n  \n  .tt-button-warning:hover {\n    background-color: #ffca2c;\n  }\n  \n  .tt-button-outline {\n    background-color: transparent;\n    border-color: var(--tt-border);\n    color: var(--tt-muted);\n  }\n  \n  .tt-button-outline:hover {\n    background-color: var(--tt-light);\n    color: var(--tt-dark);\n  }\n  \n  .tt-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none !important;\n  }\n  \n  /* ==================== CARDS ====================  */\n  \n  .tt-card {\n    background-color: #ffffff;\n    border: 1px solid var(--tt-border);\n    border-radius: var(--tt-radius);\n    padding: var(--tt-spacing-md);\n    margin-bottom: var(--tt-spacing-md);\n    box-shadow: var(--tt-shadow-sm);\n    transition: box-shadow 0.2s ease;\n  }\n  \n  .tt-card:hover {\n    box-shadow: var(--tt-shadow-md);\n  }\n  \n  .tt-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: var(--tt-spacing-md);\n    padding-bottom: var(--tt-spacing-sm);\n    border-bottom: 1px solid var(--tt-border);\n  }\n  \n  .tt-card-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--tt-dark);\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: var(--tt-spacing-xs);\n  }\n  \n  .tt-card-subtitle {\n    font-size: 12px;\n    color: var(--tt-muted);\n    margin: var(--tt-spacing-xs) 0 0 0;\n  }\n  \n  /* ==================== TABLES ====================  */\n  \n  .tt-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 0;\n    font-size: 13px;\n  }\n  \n  .tt-table thead {\n    background-color: var(--tt-light);\n    border-bottom: 2px solid var(--tt-border-dark);\n  }\n  \n  .tt-table th {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--tt-dark);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: var(--tt-spacing-sm);\n    text-align: left;\n    border-color: var(--tt-border-dark);\n  }\n  \n  .tt-table td {\n    padding: var(--tt-spacing-sm);\n    border-bottom: 1px solid var(--tt-border);\n    vertical-align: middle;\n    color: var(--tt-dark);\n  }\n  \n  .tt-table tbody tr:hover {\n    background-color: var(--tt-light);\n  }\n  \n  .tt-table tbody tr:nth-child(even) {\n    background-color: #fafbfc;\n  }\n  \n  .tt-table-align-right {\n    text-align: right;\n  }\n  \n  .tt-table-align-center {\n    text-align: center;\n  }\n  \n  /* ==================== BADGES ====================  */\n  \n  .tt-badge {\n    display: inline-block;\n    padding: var(--tt-spacing-xs) var(--tt-spacing-sm);\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n  \n  .tt-badge-primary {\n    background-color: var(--tt-primary);\n    color: #ffffff;\n  }\n  \n  .tt-badge-success {\n    background-color: var(--tt-success);\n    color: #ffffff;\n  }\n  \n  .tt-badge-danger {\n    background-color: var(--tt-danger);\n    color: #ffffff;\n  }\n  \n  .tt-badge-warning {\n    background-color: var(--tt-warning);\n    color: #000000;\n  }\n  \n  .tt-badge-info {\n    background-color: var(--tt-info);\n    color: #ffffff;\n  }\n  \n  .tt-badge-light {\n    background-color: var(--tt-light);\n    color: var(--tt-dark);\n    border: 1px solid var(--tt-border);\n  }\n  \n  /* ==================== STAT CARDS ====================  */\n  \n  .tt-stat-card {\n    text-align: center;\n    padding-bottom: var(--tt-spacing-lg);\n  }\n  \n  .tt-stat-icon {\n    font-size: 28px;\n    margin-bottom: var(--tt-spacing-sm);\n  }\n  \n  .tt-stat-label {\n    font-size: 12px;\n    color: var(--tt-muted);\n    margin-bottom: var(--tt-spacing-xs);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .tt-stat-value {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--tt-primary);\n    margin-bottom: var(--tt-spacing-sm);\n  }\n  \n  .tt-stat-subtext {\n    font-size: 12px;\n    color: var(--tt-muted);\n    margin: 0;\n  }\n  \n  .tt-stat-trend {\n    display: inline-block;\n    margin-left: var(--tt-spacing-xs);\n    font-weight: 500;\n  }\n  \n  .tt-stat-trend-up {\n    color: var(--tt-success);\n  }\n  \n  .tt-stat-trend-down {\n    color: var(--tt-danger);\n  }\n  \n  /* ==================== EMPTY STATES ====================  */\n  \n  .tt-empty-state {\n    text-align: center;\n    padding: var(--tt-spacing-xl);\n    color: var(--tt-muted);\n  }\n  \n  .tt-empty-icon {\n    font-size: 48px;\n    margin-bottom: var(--tt-spacing-md);\n  }\n  \n  .tt-empty-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--tt-dark);\n    margin-bottom: var(--tt-spacing-sm);\n  }\n  \n  .tt-empty-description {\n    font-size: 13px;\n    margin-bottom: var(--tt-spacing-md);\n    line-height: 1.5;\n  }\n  \n  /* ==================== LOADING STATES ====================  */\n  \n  .tt-loading {\n    text-align: center;\n    padding: var(--tt-spacing-xl);\n  }\n  \n  .tt-loading-spinner {\n    margin-bottom: var(--tt-spacing-md);\n  }\n  \n  .tt-loading-text {\n    color: var(--tt-muted);\n    font-size: 13px;\n  }\n  \n  /* ==================== TABS ====================  */\n  \n  .tt-tabs {\n    background-color: #ffffff;\n    border-radius: var(--tt-radius-lg);\n    box-shadow: var(--tt-shadow-sm);\n    overflow: hidden;\n  }\n  \n  .tt-tabs-nav {\n    display: flex;\n    border-bottom: 2px solid var(--tt-border);\n    background-color: var(--tt-light);\n    overflow-x: auto;\n  }\n  \n  .tt-tab-button {\n    padding: var(--tt-spacing-md) var(--tt-spacing-lg);\n    border: none;\n    background-color: transparent;\n    color: var(--tt-muted);\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 13px;\n    white-space: nowrap;\n    transition: all 0.2s ease;\n    border-bottom: 3px solid transparent;\n    margin-bottom: -2px;\n  }\n  \n  .tt-tab-button:hover {\n    color: var(--tt-dark);\n    background-color: rgba(13, 110, 253, 0.05);\n  }\n  \n  .tt-tab-button.active {\n    color: var(--tt-primary);\n    border-bottom-color: var(--tt-primary);\n  }\n  \n  .tt-tab-badge {\n    display: inline-block;\n    background-color: var(--tt-danger);\n    color: #ffffff;\n    border-radius: 10px;\n    padding: 2px 6px;\n    font-size: 10px;\n    font-weight: 600;\n    margin-left: var(--tt-spacing-xs);\n    vertical-align: middle;\n  }\n  \n  .tt-tab-content {\n    padding: var(--tt-spacing-lg);\n  }\n  \n  /* ==================== FORMS ====================  */\n  \n  .tt-form-group {\n    margin-bottom: var(--tt-spacing-md);\n  }\n  \n  .tt-form-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--tt-dark);\n    margin-bottom: var(--tt-spacing-xs);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .tt-form-input,\n  .tt-form-select {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    font-size: 13px;\n    border: 1px solid var(--tt-border);\n    border-radius: var(--tt-radius);\n    background-color: #ffffff;\n    color: var(--tt-dark);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n  \n  .tt-form-input:focus,\n  .tt-form-select:focus {\n    outline: none;\n    border-color: var(--tt-primary);\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n  }\n  \n  .tt-form-input:disabled,\n  .tt-form-select:disabled {\n    background-color: var(--tt-light);\n    color: var(--tt-muted);\n    cursor: not-allowed;\n  }\n  \n  /* ==================== RESPONSIVE ====================  */\n  \n  @media (max-width: 768px) {\n    .tt-page-title {\n      font-size: 20px;\n    }\n  \n    .tt-controls {\n      padding: var(--tt-spacing-md);\n    }\n  \n    .tt-card {\n      padding: var(--tt-spacing-sm);\n    }\n  \n    .tt-table {\n      font-size: 12px;\n    }\n  \n    .tt-table th,\n    .tt-table td {\n      padding: var(--tt-spacing-xs);\n    }\n  \n    .tt-tab-button {\n      padding: var(--tt-spacing-sm) var(--tt-spacing-md);\n      font-size: 12px;\n    }\n  \n    .tt-stat-value {\n      font-size: 20px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .tt-page-title {\n      font-size: 18px;\n    }\n  \n    .tt-tabs-nav {\n      flex-wrap: wrap;\n    }\n  \n    .tt-tab-button {\n      padding: var(--tt-spacing-xs) var(--tt-spacing-sm);\n      font-size: 11px;\n    }\n  \n    .tt-stat-icon {\n      font-size: 24px;\n    }\n  \n    .tt-stat-value {\n      font-size: 18px;\n    }\n  }\n  \n  /* ==================== UTILITIES ====================  */\n  \n  .tt-text-center {\n    text-align: center;\n  }\n  \n  .tt-text-right {\n    text-align: right;\n  }\n  \n  .tt-text-muted {\n    color: var(--tt-muted);\n  }\n  \n  .tt-text-success {\n    color: var(--tt-success);\n  }\n  \n  .tt-text-danger {\n    color: var(--tt-danger);\n  }\n  \n  .tt-text-warning {\n    color: var(--tt-warning);\n  }\n  \n  .tt-text-primary {\n    color: var(--tt-primary);\n  }\n  \n  .tt-mb-0 {\n    margin-bottom: 0;\n  }\n  \n  .tt-mb-1 {\n    margin-bottom: var(--tt-spacing-xs);\n  }\n  \n  .tt-mb-2 {\n    margin-bottom: var(--tt-spacing-sm);\n  }\n  \n  .tt-mb-3 {\n    margin-bottom: var(--tt-spacing-md);\n  }\n  \n  .tt-mb-4 {\n    margin-bottom: var(--tt-spacing-lg);\n  }\n  \n  .tt-mb-5 {\n    margin-bottom: var(--tt-spacing-xl);\n  }\n  \n  .tt-mt-0 {\n    margin-top: 0;\n  }\n  \n  .tt-mt-1 {\n    margin-top: var(--tt-spacing-xs);\n  }\n  \n  .tt-mt-2 {\n    margin-top: var(--tt-spacing-sm);\n  }\n  \n  .tt-mt-3 {\n    margin-top: var(--tt-spacing-md);\n  }\n  \n  .tt-mt-4 {\n    margin-top: var(--tt-spacing-lg);\n  }\n  \n  .tt-mt-5 {\n    margin-top: var(--tt-spacing-xl);\n  }\n  \n  .tt-p-0 {\n    padding: 0;\n  }\n  \n  .tt-p-1 {\n    padding: var(--tt-spacing-xs);\n  }\n  \n  .tt-p-2 {\n    padding: var(--tt-spacing-sm);\n  }\n  \n  .tt-p-3 {\n    padding: var(--tt-spacing-md);\n  }\n  \n  .tt-p-4 {\n    padding: var(--tt-spacing-lg);\n  }\n  \n  .tt-p-5 {\n    padding: var(--tt-spacing-xl);\n  }\n  \n  .tt-gap-1 {\n    gap: var(--tt-spacing-xs);\n  }\n  \n  .tt-gap-2 {\n    gap: var(--tt-spacing-sm);\n  }\n  \n  .tt-gap-3 {\n    gap: var(--tt-spacing-md);\n  }\n  \n  .tt-gap-4 {\n    gap: var(--tt-spacing-lg);\n  }\n  \n  .tt-gap-5 {\n    gap: var(--tt-spacing-xl);\n  }\n  \n  .tt-d-flex {\n    display: flex;\n  }\n  \n  .tt-d-grid {\n    display: grid;\n  }\n  \n  .tt-align-items-center {\n    align-items: center;\n  }\n  \n  .tt-justify-content-between {\n    justify-content: space-between;\n  }\n  \n  .tt-justify-content-center {\n    justify-content: center;\n  }\n  \n  .tt-flex-wrap {\n    flex-wrap: wrap;\n  }\n  \n  .tt-w-100 {\n    width: 100%;\n  }\n  \n  .tt-h-100 {\n    height: 100%;\n  }\n  \n  .tt-overflow-hidden {\n    overflow: hidden;\n  }\n  \n  .tt-overflow-auto {\n    overflow: auto;\n  }\n  \n  .tt-cursor-pointer {\n    cursor: pointer;\n  }\n  \n  .tt-cursor-default {\n    cursor: default;\n  }\n  \n  .tt-opacity-50 {\n    opacity: 0.5;\n  }\n  \n  .tt-opacity-75 {\n    opacity: 0.75;\n  }\n  \n  .tt-rounded {\n    border-radius: var(--tt-radius);\n  }\n  \n  .tt-rounded-lg {\n    border-radius: var(--tt-radius-lg);\n  }\n  \n  .tt-shadow-sm {\n    box-shadow: var(--tt-shadow-sm);\n  }\n  \n  .tt-shadow-md {\n    box-shadow: var(--tt-shadow-md);\n  }\n  \n  .tt-shadow-lg {\n    box-shadow: var(--tt-shadow-lg);\n  }\n  \n  .tt-border {\n    border: 1px solid var(--tt-border);\n  }\n  \n  .tt-border-bottom {\n    border-bottom: 1px solid var(--tt-border);\n  }\n  \n  .tt-border-top {\n    border-top: 1px solid var(--tt-border);\n  }\n  \n  .tt-nowrap {\n    white-space: nowrap;\n  }\n  \n  .tt-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
